import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

function SimpleValue(props) {
  return (
    <div className="data">
      <div className="icon">
        {props.icon !== undefined ? <FontAwesomeIcon icon={props.icon} /> : ''}
      </div>
      <div className="data-content">
        <span className="value">
          {props.data !== undefined
            ? props.data.value !== undefined
              ? props.data.value
              : 'Missing value'
            : 'Missing data'}
        </span>
      </div>
    </div>
  )
}

export default SimpleValue
